export const DS = {
  color: {
    // Neutrales — Blanco + Grises
    white: '#FFFFFF',
    ivory: '#F5F5F5',
    linen: '#ECECEC',
    border: '#E0E0E0',
    muted: '#808080',
    body: '#555555',
    ink: '#1A1A1A',
    ink2: '#1A1A1A',
    inkDeep: '#0E5A70',
    kraft: '#808080',

    // Teal/Aqua — más vivos
    tealDeep: '#0E5A70',
    teal: '#0E7A95',
    aqua: '#2DD4D4',
    aquaLight: '#5FE3E3',
    mint: '#D4F1F1',

    // CTA primario — cian de marca usado en los botones de acción principales
    cta: '#00AAD4',
    ctaHover: '#0099CC',

    // Secundarios
    warning: '#FF6B35',
    success: '#4CAF50',
    error: '#E53935',
  },
  font: {
    heading: "'Quicksand', sans-serif",
    body: "'Manrope', sans-serif",
  },
  radius: {
    pill: '100px',
    cardLg: '24px',
    card: '16px',
  },
  shadow: {
    card: '0 2px 12px rgba(13,42,54,0.08)',
    cardHover: '0 12px 40px rgba(13,42,54,0.16)',
    featured: '0 24px 80px rgba(13,42,54,0.22)',
    glowSm: '0 0 24px rgba(75,199,210,0.3)',
    glow: '0 0 48px rgba(75,199,210,0.4)',
  },
  ease: {
    smooth: 'cubic-bezier(0.4, 0, 0.2, 1)',
    expo: 'cubic-bezier(0.16, 1, 0.3, 1)',
    out: 'cubic-bezier(0, 0, 0.2, 1)',
  },
  wa: 'https://wa.me/573016539065',
  phone: '573016539065',
} as const

export const ASSETS = {
  alignerRender:
    'https://cdn.magicpatterns.com/patterns/generated-images/ca41b52b-51c2-4d01-9ee2-9208d8cf359e.jpg',
  kitPremium:
    'https://cdn.magicpatterns.com/patterns/generated-images/8d3d036d-9e50-4109-85c3-6ed00f4bb5f7.jpg',
} as const
